module.exports = __webpack_public_path__ + "img/keyboard_arrow_left.47647016.svg";